import type {OperationVariables, QueryHookOptions} from '@apollo/client';
import {useQuery as useQueryOrig} from '@apollo/client';
import type {DocumentNode} from 'graphql';

import type {QueryResult} from '../types';

export const useQuery = <
  TData = any,
  TVariables extends OperationVariables = OperationVariables,
>(
  query: DocumentNode,
  options?: QueryHookOptions<TData, TVariables>,
): QueryResult<TData, TVariables> => {
  const result = useQueryOrig<TData, TVariables>(query, {
    notifyOnNetworkStatusChange: true,
    returnPartialData: false,
    ...options,
  });
  if (result.networkStatus === 4) {
    result.loading = true;
    result.error = undefined;
  }
  // if (options?.fetchPolicy === 'cache-and-network' && result.data) {
  //   result.loading = false;
  // }
  return result as any;
};
